import { Box, Text } from '@ttoss/ui';

// import Button from '../Button/Button';
import ChartEvapotranspiration, {
  ChartEvapotranspirationProps,
} from '../ChartEvapotranspiration/ChartEvapotranspiration';
import ChartHydricBalance, {
  ChartHydricBalanceProps,
} from '../ChartHydricBalance/ChartHydricBalance';
import ChartSoilWaterStorage, {
  ChartSoilWaterStorageProps,
} from '../ChartSoilWaterStorage/ChartSoilWaterStorage';
import ChartSolarRadiation, {
  ChartSolarRadiationProps,
} from '../ChartSolarRadiation/ChartSolarRadiation';
import ChartTemperature, {
  TemperatureChartProps,
} from '../ChartTemperature/ChartTemperature';

export type RecommendationsChartsProps = {
  dataChartEvapotranspiration?: ChartEvapotranspirationProps['data'];
  dataChartHydricBalance?: ChartHydricBalanceProps['data'];
  dataChartSoilWaterStorage?: ChartSoilWaterStorageProps['data'];
  dataChartSolarRadiation?: ChartSolarRadiationProps['data'];
  dataChartTemperature?: TemperatureChartProps['data'];

  onClickShowAtlas?: () => void;
};

export const RecommendationsCharts = ({
  dataChartTemperature = [],
  dataChartHydricBalance = [],
  dataChartSoilWaterStorage = [],
  dataChartEvapotranspiration = [],
  dataChartSolarRadiation = [],
}: RecommendationsChartsProps) => {
  return (
    <Box>
      <Text
        sx={{
          fontFamily: 'heading',
          fontSize: 2,
          color: '#000000',
          fontWeight: 'heading',
        }}
      >
        Características do Local
      </Text>

      {dataChartTemperature?.length > 0 && (
        <Box
          aria-label="chart-temperature"
          className="chart-container"
          sx={{ marginBottom: [10], marginTop: [7, 8] }}
        >
          <ChartTemperature data={dataChartTemperature} />
        </Box>
      )}

      {dataChartHydricBalance?.length > 0 && (
        <Box
          className="chart-container"
          aria-label="chart-hydric-balance"
          sx={{ marginBottom: [10] }}
        >
          <ChartHydricBalance data={dataChartHydricBalance} />
        </Box>
      )}

      {dataChartSoilWaterStorage?.length > 0 && (
        <Box
          className="chart-container"
          aria-label="chart-soil-water-storage"
          sx={{ marginBottom: [10] }}
        >
          <ChartSoilWaterStorage data={dataChartSoilWaterStorage} />
        </Box>
      )}

      {dataChartEvapotranspiration?.length > 0 && (
        <Box
          className="chart-container"
          aria-label="chart-evapotranspiration"
          sx={{ marginBottom: [10] }}
        >
          <ChartEvapotranspiration data={dataChartEvapotranspiration} />
        </Box>
      )}

      {dataChartSolarRadiation?.length > 0 && (
        <Box
          className="chart-container"
          aria-label="chart-solar-radiation"
          sx={{ marginBottom: [11, 10] }}
        >
          <ChartSolarRadiation data={dataChartSolarRadiation} />
        </Box>
      )}

      {/* <Box
        sx={{
          fontFamily: 'body',
          fontSize: [3],
          marginBottom: [9],
          paddingX: [5, 7],
        }}
      >
        <Text
          as="p"
          sx={{
            marginBottom: [6, 7],
          }}
        >
          <Text sx={{ fontWeight: 'heading' }}>Tipo de solo:</Text> latosolo
          amarelo distrófico típico
        </Text>

        <Text as="p">
          <Text sx={{ fontWeight: 'heading' }}>Textura de solo:</Text> arenosa
        </Text>
      </Box>
      <Flex sx={{ justifyContent: 'center', marginBottom: [9] }}>
        <Button onClick={onClickShowAtlas}>Ver Atlas Biofísico</Button>
      </Flex> */}
    </Box>
  );
};

export default RecommendationsCharts;
